<script setup lang="ts" generic="T extends string">
import { RadioGroupItem, RadioGroupRoot } from 'radix-vue'

const value = defineModel<T>()

withDefaults(
  defineProps<{
    options: { value: T; title: string }[]
  }>(),
  {
    options: () => []
  }
)
</script>

<template>
  <radio-group-root
    class="flex w-full flex-row gap-1 flex-wrap"
    default-value="default"
    orientation="horizontal"
    v-model="value"
  >
    <radio-group-item
      v-for="item in options"
      class="px-[14px] py-2 flex items-center justify-center bg-background-inactive border border-stroke-inactive rounded-[6px] 
        font-normal text-text-soft text-xs leading-none whitespace-nowrap 
        cursor-pointer
        aria-checked:bg-background-active aria-checked:text-white/80 aria-checked:border-stroke-active
        aria-disabled:cursor-not-allowed"
      :value="item.value"
      :key="item.value"
      :aria-label="item.title"
    >
      <slot name="item-label" :item="item">{{ $t(`DrillConfig.label.${item.title}`) }}</slot>
    </radio-group-item>
  </radio-group-root>
</template>